import React from 'react';
import { IconButton, Th } from '@chakra-ui/react';
import { TriangleUpIcon, TriangleDownIcon } from '@chakra-ui/icons';

export const TableSorter = ({ display, name, sort, up }) => {
	const onClick = () => sort(name);
	const button = {
		colorScheme: 'teal',
		size: 'xs',
		icon: up ? <TriangleUpIcon /> : <TriangleDownIcon />,
	};

	return (
		<Th>
			{display}
			&nbsp;
			<IconButton {...{ ...button, onClick }} />
		</Th>
	);
};
